import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, validateUrl } from '../../utils';

export interface downloadFileOption extends Partial<GeneralInvokeOption> {
  url: string;
  header?: Object;
  timeout?: number;
}

// 下载文件资源到本地
export function downloadFile(option: downloadFileOption) {
  if (!option.url) {
    return logErrorAndRunFail(
      APINames.Native.DOWNLOAD_FILE,
      option,
      'parameter error: parameter.url should be String instead of Undefined.'
    );
  }
  if (!validateUrl(option.url)) {
    return logErrorAndRunFail(
      APINames.Native.DOWNLOAD_FILE,
      option,
      `parameter error: invalid url ${option.url}`
    );
  }
  return MacleJSBridge.beforeInvoke(APINames.Native.DOWNLOAD_FILE, option);
}
